// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"42":"2511ac1b60522c0962cc","260":"90afa6fda7b3878f2fb6","702":"c74c274743a6cbcfa196","715":"76cc97f3354cfb6f5e53"}[chunkId] + ".css";
};